export default __webpack_public_path__ + "static/media/1523.feabc820.png";